import { getInvoiceableDefaultValue, toDateString } from "helpers";
import { WritableDraft } from "immer/dist/internal";
import { Job } from "models/Job";
import { initialVisitFormValues } from "models/jobVisitForm";
import { UsedPart } from "models/usedPart";
import { MeterReadingInputType } from "operations/schema/schema";
import { State, storeVisitsToLocal } from "store/slices/jobs.store";
import { State as PartnerState, storePartnerVisitsToLocal } from "store/slices/partner.store";
import technicianSettings from "./technicianSettings";

const createVisit = (job: Job) => {
  const travelTimes = job.travelTimes.filter((tt) => tt.startTime || tt.stopTime);
  return {
    checklists: [
      ...job.checklists.map((cl) => ({
        checklist: cl,
        uploaded: false,
        hasPreStart: cl.questions.some((q) => q.isRequiredPreStart),
      })),
    ],
    files: [],
    extras: [],
    meterReadings: [
      ...job.meters.map(
        (mr) =>
          ({
            currentReading: undefined,
            currentReadingDate: undefined,
            typeId: mr.typeId,
          }) as MeterReadingInputType,
      ),
    ],
    usedParts: [
      ...job.usedParts.map(
        (p) =>
          ({
            part: p,
            maxQuantity: p.quantity,
            salesPriceChanged: false,
            uploaded: true,
            pendingUpload: true,
          }) as UsedPart,
      ),
    ],
    travelTimes: (travelTimes || []).map((tt) => ({
      startDate: toDateString(tt.startTime!),
      startTime: toDateString(tt.startTime!),
      stopDate: toDateString(tt.stopTime) || undefined,
      stopTime: toDateString(tt.stopTime) || undefined,
      uploaded: true,
      pendingUpload: true,
    })),
    travelTimesInvoiceType: getInvoiceableDefaultValue(job.contractId),
    followUp: (() => {
      let bool = !!job.preOrderedParts.length;
      return {
        followUpChecked: bool,
      };
    })(),
    signatureCustomer: undefined,
    signatureEngineer: undefined,
    autoEndTime: true,
    ...initialVisitFormValues(job),
    errors: {},
    signoffErrors: {},
    submitLoading: false,
    metersNotSaved:
      technicianSettings.requireMeterReading === true &&
      job.meters.filter((m) => m.isOnContract).length > 0,
    metersUseCurrent: false,
    reference: "",
    customerSatisfaction: undefined,
  };
};

export const initializeJobVisit = (state: WritableDraft<State>, job: Job) => {
  state.jobVisits[job.id] = createVisit(job);
  storeVisitsToLocal(state);
};

export const initializePartnerVisit = (state: WritableDraft<PartnerState>, job: Job) => {
  state.jobVisits[job.id] = createVisit(job);
  storePartnerVisitsToLocal(state);
};
